import styled from 'styled-components'
import { Radio } from './Radio'
import { Number } from './Number'
import { Slider } from './Slider'

const Inputs = ({
  questiondata,
  onChange,
  value,
  title,
  inverted = false,
  questionNumber = 0,
}: {
  questiondata: Question
  onChange: (id: string, value: string | number) => void
  value: string | number | undefined
  title?: string
  inverted?: boolean
  questionNumber?: number
}) => {
  const { inputtype, initial } = questiondata

  if (inputtype === 'radio')
    return (
      <Radio
        questionNumber={questionNumber}
        inverted={inverted}
        questiondata={questiondata}
        onChange={onChange}
        currentValue={value as string}
      />
    )

  if (inputtype === 'number')
    return (
      <Number
        questionNumber={questionNumber}
        questiondata={questiondata}
        onChange={onChange}
        currentValue={value as string}
      />
    )

  if (inputtype === 'slider')
    return (
      <Slider
        questionNumber={questionNumber}
        inverted={inverted}
        title={title}
        questiondata={questiondata}
        onChange={onChange}
        currentValue={value as number}
      />
    )
  return <InputsContainer></InputsContainer>
}

const InputsContainer = styled.div`
  font-size: 12px;
  label {
    font-size: 12px;
  }
  fieldset {
    border: none;
  }
`

export default Inputs
